var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.967 4.8-.095.324v9.408l.095.096 4.367-2.582L11.967 4.8Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.967 4.8 7.6 12.046l4.367 2.582V4.8Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.967 15.455-.053.065v3.352l.053.157 4.37-6.155-4.37 2.58Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.967 19.029v-3.574L7.6 12.875l4.367 6.154Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m11.967 14.628 4.367-2.582-4.367-1.985v4.567Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m7.6 12.046 4.367 2.582V10.06L7.6 12.046Z",
    fill: "#393939"
  })));
};
export { SvgEth as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNFREYwRjQiLz4KPHBhdGggZD0iTTExLjk2NzMgNC43OTk4TDExLjg3MTggNS4xMjQwNlYxNC41MzI0TDExLjk2NzMgMTQuNjI3NkwxNi4zMzQ0IDEyLjA0NjJMMTEuOTY3MyA0Ljc5OThaIiBmaWxsPSIjMzQzNDM0Ii8+CjxwYXRoIGQ9Ik0xMS45Njc0IDQuNzk5OEw3LjYwMDEgMTIuMDQ2MkwxMS45Njc0IDE0LjYyNzZWMTAuMDYxMVY0Ljc5OThaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGQ9Ik0xMS45Njc0IDE1LjQ1NDZMMTEuOTEzNiAxNS41MjAyVjE4Ljg3MTZMMTEuOTY3NCAxOS4wMjg3TDE2LjMzNzIgMTIuODc0NUwxMS45Njc0IDE1LjQ1NDZaIiBmaWxsPSIjM0MzQzNCIi8+CjxwYXRoIGQ9Ik0xMS45Njc0IDE5LjAyODdWMTUuNDU0Nkw3LjYwMDEgMTIuODc0NUwxMS45Njc0IDE5LjAyODdaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGQ9Ik0xMS45NjczIDE0LjYyNzZMMTYuMzM0NCAxMi4wNDYxTDExLjk2NzMgMTAuMDYxVjE0LjYyNzZaIiBmaWxsPSIjMTQxNDE0Ii8+CjxwYXRoIGQ9Ik03LjYwMDEgMTIuMDQ2MUwxMS45Njc0IDE0LjYyNzZWMTAuMDYxTDcuNjAwMSAxMi4wNDYxWiIgZmlsbD0iIzM5MzkzOSIvPgo8L3N2Zz4K";